import React from 'react';

const LogoWatermark = () => (
  <div
    className="fixed inset-0 flex items-center justify-center pointer-events-none select-none"
    style={{ zIndex: 0 }}
    aria-hidden="true"
    data-testid="logo-watermark"
  >
    <img
      src="https://customer-assets.emergentagent.com/job_og-catalog-pro/artifacts/qr8unnx1_logo%20ovalle%201.png"
      alt=""
      className="w-[50vw] max-w-[500px] opacity-[0.035]"
      style={{ filter: 'grayscale(100%) brightness(2.5)' }}
      draggable={false}
    />
  </div>
);

export default LogoWatermark;
